/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import { CrossIcon } from '../icons'

class GuidanceText extends Component {
  state = {
    isVisible: true,
  }

  handleClick = () => {
    this.setState({
      isVisible: false,
    })
  }

  render = () => {
    const notices = getNotices({
      guidanceText: this.props.guidanceText,
      informationText: this.props.informationText,
      competitionText: this.props.competitionText,
    })

    if (!this.state.isVisible || !notices.length) return null

    return (
      <div className="GuidanceText">
        <div className="guidance-text-wrapper">
          {
            notices.map(({
              textContent,
              warningCharacter,
            }) => (
              <div className="notice" key={textContent}>
                <span className="warning-character">{warningCharacter}</span>
                <span className="text-content">{textContent}</span>
              </div>
            ))
          }
        </div>
        <div className="close-icon-wrapper">
          <button
            className="close-icon button-reset"
            onClick={this.handleClick}
            type="button"
          >
            <CrossIcon color="#680f0d" />
          </button>
        </div>
        <style jsx>{styles}</style>
      </div>
    )
  }
}

GuidanceText.propTypes = {
  guidanceText: PropTypes.string,
  informationText: PropTypes.string,
  competitionText: PropTypes.string,
}

GuidanceText.defaultProps = {
  guidanceText: '',
  informationText: '',
  competitionText: '',
}

export function getNotices(notices) {
  return Object
    .entries(notices)
    .filter(([key, textContent]) => Boolean(textContent))
    .map(([key, textContent]) => ({
      warningCharacter: key === 'guidanceText' ? 'G' : '!',
      textContent,
    }))
}

export default GuidanceText
